import { RouterProvider } from "@tanstack/react-router";
import { Providers } from "@/app/providers";
import { router } from "@/app/router";
import { AnalyticsBridge } from "@/shared/analytics/analytics-bridge";
import { AnalyticsConsentBanner } from "@/shared/integrations/analytics-consent-banner";

export function App() {
  return (
    <Providers>
      {/* Renders nothing: reports the page journey and identifies the person.
          Sits inside Providers (needs auth + entitlements) and beside the
          router rather than under it, so the instance is passed as a prop. */}
      <AnalyticsBridge router={router} />
      <RouterProvider router={router} />
      <AnalyticsConsentBanner />
    </Providers>
  );
}
